module.exports = __webpack_public_path__ + "static/media/Hours40.8ab7aecc.png";